import { useEffect, useRef } from 'react';

interface Props {
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}

export function ConfirmModal({ message, confirmLabel = 'Confirm', danger = false, onConfirm, onCancel }: Props): JSX.Element {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const confirmRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    (onCancel ? cancelRef.current : confirmRef.current)?.focus();
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70" onClick={onCancel} />
      <div className="relative bg-gray-900 border border-gray-700 rounded-lg p-6 max-w-sm w-full shadow-xl">
        <p className="text-sm text-gray-200 whitespace-pre-wrap mb-6">{message}</p>
        <div className="flex gap-3 justify-end">
          {onCancel && (
            <button ref={cancelRef} className="btn-secondary" onClick={onCancel}>
              Cancel
            </button>
          )}
          <button
            ref={confirmRef}
            className={danger ? 'btn-danger' : 'btn-primary'}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
